import forEach from 'lodash/forEach'

//
// Helpers
//

// Here we don't use "toggle()" because:
// https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/11865865/
function toggle(element, className, force) {
  if (!element) {
    return
  }

  if (force) {
    element.classList.add(className)
    if (element.querySelector('.accordion__item-title')) {
      element.querySelector('.accordion__item-title').setAttribute('aria-expanded', true)
    }
  } else {
    element.classList.remove(className)
    if (element.querySelector('.accordion__item-title')) {
      element.querySelector('.accordion__item-title').setAttribute('aria-expanded', false)
    }
  }
}

//
// Accordion
//
function toggleItem(item, target) {
  const title = item.querySelector('.accordion__item-title')
  const arrow = item.querySelector('[class*="accordion__icon--arrow-"]')
  const isOpen = !!title.querySelector('.accordion__icon--arrow-up')
  const force = isOpen ? false : target === title

  toggle(item, 'accordion__item--open', force)
  toggle(arrow, 'accordion__icon--arrow-up', force)
  toggle(arrow, 'accordion__icon--arrow-down', !force)
}

//
// Initialize
//
document.addEventListener('DOMContentLoaded', () => {
  forEach(document.querySelectorAll('.accordion'), (root) => {
    const items = root.querySelectorAll('.accordion__item')

    forEach(items, (item) => {
      const title = item.querySelector('.accordion__item-title')

      title.addEventListener('click', () => {
        toggleItem(item, title)
      })

      title.addEventListener('keyup', (e) => {
        const key = e.which || e.keyCode
        if (key === 13) { // 13 is enter
          // code for enter
          toggleItem(item, title)
        }
      })
    })
  })
})
